import BreakpointEnum from '@models/enums/BreakpointEnum';
import { useCallback, useEffect, useState } from 'react';

const getCurrentBreakpoint = () => {
  const breakpoints = { tablet: 768, desktop: 1024, lgDesktop: 1440 };
  const width = window.innerWidth;

  if (width < breakpoints.tablet) {
    return BreakpointEnum.Small;
  }
  if (width >= breakpoints.tablet && width < breakpoints.desktop) {
    return BreakpointEnum.Medium;
  }
  if (width >= breakpoints.desktop && width < breakpoints.lgDesktop) {
    return BreakpointEnum.Large;
  }
  return BreakpointEnum.XLarge;
};

const useBreakpoint = () => {
  const [screen, setScreen] = useState<BreakpointEnum>();

  const resizeHandler = useCallback(
    () => setScreen(getCurrentBreakpoint()),
    []
  );

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    setScreen(getCurrentBreakpoint());

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);

  return screen;
};

export default useBreakpoint;
